import { company_name } from "@/i18n/variables";

const sign_up = {
	/* -------------------------------------------------------------------------- */
	/*                                FORM SECTION                                */
	/* -------------------------------------------------------------------------- */
	form: {
		confirmation: {
			description:
				"Uw nieuwe account is succesvol geregistreerd. Om zeker te weten dat we u kunnen bereiken hebben wij een email bevestiging verstuurd. U kunt deze pagina nu afsluiten.",
			title: "Email bevestiging gestuurd",
		},
		debtor_info: {
			description:
				"Vraag een collega met een account om een account voor u aan te maken tenzij dit de eerste keer is dat uw bedrijf gebruik maakt van Portal. Dan kunt u eenmalig inloggen met de inloggegevens die u gebruikt voor klanten.tuxis.nl. Ben u het klanten.tuxis.nl wachtwoord vergeten? Lees <password_reset_link>hier</password_reset_link> hoe uw het wachtwoord kan herstellen.",
			title: "U hoeft geen account aan te maken!",
		},
		descriptions: {
			billing: "Hier wordt de factuur naar toe gestuurd.",
			debtor:
				"Vul hieronder uw persoonlijke gegevens in voor het creëren van een account. Zakelijke gebruikers kunnen later nog andere personen of collega's toevoegen.",
		},
		foreign_private_debtor_warning:
			"Let op! Als particulier kunt u alleen gratis diensten afnemen.",
		labels: {
			accept_conditions: "Ik accepteer de",
			has_debtor_code: "Hebt u al een debiteurnummer?",
			privacy_policy: "algemene voorwaarden",
		},
		password_strength: {
			bad: "Slecht",
			good: "Uitstekend",
			medium: "Zeer matig",
			okay: "Redelijk",
			passwords_no_match: "Wachtwoorden komen niet overeen!",
			too_short: "Te kort",
		},
		progress_bar: {
			address: "Adres- en bedrijfsgegevens",
			debtor: "Persoonlijke gegevens",
		},
		terms: {
			label: "Algemene voorwaarden",
			text: {
				part1: "Ik ga akkoord met de",
				part2: "algemene voorwaarden",
				part3: `van ${company_name}`,
			},
		},
		tips: {
			debtor_code: `Uw debiteurnummer kunt u vinden op elke factuur die u van ${company_name} krijgt. Dit nummer begint met DB en eindigt met 4 cijfers.`,
		},
		titles: {
			account: "Uw accountgegevens",
			address: "Adresgegevens afnemer",
			billing: "Facturatiegegevens",
			debtor: "Uw persoonlijke gegevens",
			user: "Uw inloggegevens",
		},
		values: {
			no: "Nee",
			yes: "Ja",
		},
	},

	verification: {
		account_verification_card: {
			body: "Gebruik de onderstaande link om een betaling van € 0,01 te voltooien ter verificatie van uw gegevens. Kunt u dit niet zelf, dan mag u de link ook doorsturen. \nNa betaling ontvangt u een mail dat uw account geactiveerd is.",
			button: "Start verificatie betaling (€ 0.01)",
			title: "Account Verificatie",
		},
	},
};

export default sign_up;
